import { render, staticRenderFns } from "./VerticalNav.vue?vue&type=template&id=3c495f08&scoped=true&"
import script from "./VerticalNav.vue?vue&type=script&lang=js&"
export * from "./VerticalNav.vue?vue&type=script&lang=js&"
import style0 from "./VerticalNav.vue?vue&type=style&index=0&id=3c495f08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c495f08",
  null
  
)

export default component.exports